export enum Language {
  EN = "EN",
  DE = "DE",
  IT = "IT",
  FR = "FR",
  NL = "NL"
}
